// Barrel export for all contact config modules
export { coreContactFields } from "./contact-fields-core";
export { companyContactFields } from "./contact-fields-company";
export { dealsContactFields } from "./contact-fields-deals";
export { locationContactFields } from "./contact-fields-location";
export { statusContactFields } from "./contact-fields-status";
export { metadataContactFields } from "./contact-fields-metadata";
export { extendedContactFields } from "./contact-fields-extended";
export { contactActions, contactDetailActions, contactBulkActions } from "./contact-actions";
export { contactSavedViews, contactCustomFilterHooks } from "./contact-saved-views";
export { contactFeatures } from "./contact-features";
export { CONTACT_FIELDS, type ContactFieldId } from "./contact-field-ids";
